import BuyMeACoffee from "@/components/BuyMeACoffie";
import { useUser, withPageAuthRequired } from "@auth0/nextjs-auth0";
import {
  Alert,
  Card,
  CardActionArea,
  CardContent,
  CardHeader,
  CircularProgress,
  Grid,
  LinearProgress,
  Stack,
  useTheme
} from "@mui/material";
import Container from "@mui/material/Container";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import { Box } from "@mui/system";
import Head from "next/head";
import Image from "next/image";
import { useRouter } from "next/router";
import { DashboardLayout } from "../../components/dashboard/DashboardLayout";
import { reducer, sliceKey } from "../../store/dashboard/slice";
import { useInjectReducer } from "../../utils/redux-injectors";

function Copyright(props: any) {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      align="center"
      {...props}
    >
      {"Copyright © "}
      <Link color="inherit" href="https://tradingpnl.in/">
        Tradingpnl.in
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

export function BrokerCard(props: any) {
  return (
      <Card>
        <CardActionArea onClick={props.onClick}>
        <CardContent>
            <Stack direction="row" alignItems="center">
              <Image
                src={props.image}
                alt={props.imageAlt}
                width={60}
                height={60}
              />
              <Box mr={2} />
              <Typography variant="h1">{props.text}</Typography>
            </Stack>
        </CardContent>
        </CardActionArea>
      </Card>
  );
}

const Dashboard = () => {
  useInjectReducer({ key: sliceKey, reducer: reducer });
  const theme = useTheme();
  const { isLoading } = useUser();
  const router = useRouter();
  return (
    <DashboardLayout>
      <Head>
        <title>Home | Tradingpnl.in</title>
      </Head>
      {isLoading && <LinearProgress variant="indeterminate" />}
      <Container>
        <Box sx={{ mt: 5 }}>
          <Card elevation={0} sx={{backgroundColor: theme.palette.background.default}}>
            <CardHeader
              title="Select a broker and start analysing"
              action={<BuyMeACoffee />}
            />
            <CardContent>
              <Alert severity="info">This is a personal project. I actively test Finvasia only. If you see any error with other brokers please let me know in <a href="mailto:support@tradingpnl.in" >support@tradingpnl.in</a> so that we can fix it together.</Alert>
              <Alert severity="info">Trading pnl shows the analysis for realized pnl only. If the buy and sell trade transactions are not present in the report you are uploading, the tool will not consider the trade.</Alert>
              <Grid container spacing={4} sx={{mt: 1}} justifyContent="space-around">
                <Grid item xs={12} md={6}>
                  <BrokerCard
                    onClick={() => router.push("/dashboard/upstox")}
                    image="/upstox.png"
                    imageAlt="upstox"
                    text="Upstox"
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <BrokerCard
                    onClick={() => router.push("/dashboard/angel")}
                    image="/angel.webp"
                    imageAlt="angel"
                    text="Angel"
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <BrokerCard
                    onClick={() => router.push("/dashboard/zerodha")}
                    image="/zerodha.jpeg"
                    imageAlt="zerodha"
                    text="Zerodha"
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <BrokerCard
                    onClick={() => router.push("/dashboard/finvasia")}
                    image="/finvasia.png"
                    imageAlt="finvasia"
                    text="Finvasia"
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <BrokerCard
                    onClick={() => router.push("/dashboard/fyers")}
                    image="/fyerslogo.png"
                    imageAlt="fyers"
                    text="Fyers"
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Box>
        <Copyright sx={{ pt: 4 }} />
      </Container>
    </DashboardLayout>
  );
};

export default withPageAuthRequired(Dashboard, {
  onRedirecting: () => (
    <Box
      sx={{ height: "100vh" }}
      display={"flex"}
      justifyContent={"center"}
      alignItems={"center"}
    >
      <CircularProgress variant="indeterminate" />
    </Box>
  ),
  onError: (error) => <Typography>{error.message}</Typography>,
});
